import React, { useEffect, useState, forwardRef,useMemo } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate, useLocation } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import LookupComponent from "../../HelperComponent/LookupComponent";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";
import ConstantData from "../../../Utils/Constant";
import {Select,MenuItem,InputLabel, Typography} from "@mui/material";
import InfoModal from "../../../helpers/CommonModal/InfoModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import HazardInfoModal from "../../../helpers/CommonModal/HazardInfoModal";
import { arraysHaveSameElements } from "../../../helpers/dataHelper";
export const FilterLayout = forwardRef((props, ref) => {
  const [showbyOptions, setShowbyOptions] = useState([]);
  const [filterbyOptions, setFilterbyOptions] = useState([]);
  const [defaultShowby, setDefaultShowby] = useState();
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [initialShowbyOptions, setInitialShowbyOptions] = useState([]);
  const [initialFilterbyOptions, setInitialFilterbyOptions] = useState([]);
  const [initialDefaultShowby, setInitialDefaultShowby] = useState();
  const [appendingPins, setAppendingPins] = React.useState(true);

  let disableCheckBox =useMemo(()=>localStorage.getItem('user') !== null && JSON.parse(localStorage.getItem('user')).usertype === 'Free' ?true:false,[]) || props?.demoMarket;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filterObjectData = useSelector((state) => state.filterObjectData);
  const searchPinAppending = useSelector((state) => state.searchPinAppending);
  const location = useLocation();
  const isDisableCheckBox=disableCheckBox && ["/market-search","/sample-market"].includes(location.pathname) ? true : !!appendingPins ;
  const disableShowByFilters=props?.demoMarket ? true : (appendingPins || isDisableCheckBox);
  const developmentFilters = useSelector((state) => state.developmentFilters);
  const activeTileSet = useSelector((state) => state.activeTileSet);
  const filterOptions = useSelector((state) => state.filterbyOptions);
  const [mapOverLaysLookUp,setMapOverlaysLookup]=useState();
  const [hazardInfo,setHazardInfo] = useState({show:false,info:null});
  const viewPort=useSelector((state)=>state.viewPort);
  const isTrafficReset = useSelector((state) => state.isTrafficReset);

  useEffect(async () => {
    if (filterObjectData) {
      await handleRadioChange(
        { target: { value: filterObjectData.radioid } },
        false
      );
      const { glampingfilters, koafilters, sizefilters } = filterObjectData;

      let combinedFilters = [
        ...glampingfilters.split(","),
        ...koafilters.split(","),
        ...sizefilters.split(","),
      ];
      const jsonArray = filterbyOptions;
      jsonArray.forEach((item) => {
        item.isactive = false;
      });

      for (let jsonValue of jsonArray) {
        if (combinedFilters.includes(jsonValue.id.toString())) {
          jsonValue.isactive = true;
        }
      }
      const filteredIds = jsonArray
        .filter(
          (item) =>
            item.isactive === true &&
            item.typeid === parseInt(filterObjectData.radioid)
        )
        .map((item) => item.id);
      await props.fetchDataFromChild(filterObjectData.radioid, jsonArray);

      const objvalue = { [filterObjectData.radioid.toString()]: filteredIds };
      setSelectedFilters(objvalue);
      dispatch({ type: "filterObjectData", value: null });
    }
  }, [filterObjectData]);

  useEffect(() => {
    setAppendingPins(searchPinAppending);
  }, [searchPinAppending]);

  const fetchShowbyOptions = (isReset = false) => {
    apiCommonTrigger("get" , Config.API_URL + "/Lookup/mapsettings")
      .then((res) => {
        if (res.status === 200) {
          const options = res.data;
          setShowbyOptions(options);
          const defaultObject = options.find((item) => item.isdefault === true);

          const filters = defaultObject.filterids
            .split(",")
            .map((id) => Number(id));

          const objvalue = { [defaultObject.id.toString()]: filters };
          setSelectedFilters(objvalue);

          dispatch({ type: "activeCheckList", value: objvalue });
          setSelectedFilters(objvalue);          
          dispatch({ type: 'activeCheckList' , value : objvalue});
          setInitialShowbyOptions(options);
          const defaultOption = options.find((val) => val.isdefault);
          if (defaultOption) {
            setDefaultShowby(defaultOption.id);
            setInitialDefaultShowby(defaultOption.id);
          }

          fetchFilterbyOptions(defaultOption.id, isReset);
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };

  const fetchFilterbyOptions = (id , isReset = false) => {
    apiCommonTrigger("get" , Config.API_URL + "/Lookup/maptypes")
      .then(async (res) => {
        if (res.status === 200) {

          let options = res.data;
          dispatch({ type: 'initialFilterIds', value: options?.filter((ele)=>ele?.isactive).map((ele)=>ele?.id) });
          const mapCountResult = await apiCommonTrigger("get" , Config.API_URL + "/Lookup/filter/counts");
          options.forEach(item1 => {
            // Find a matching object in the second array by 'id'
            const matchingItem = mapCountResult.data.find(
              (item2) => item2.id === item1.id
            );

            // If a match is found, update profilecount in the first array
            if (matchingItem) {
              item1.profilecount = matchingItem.profilecount;
            }
          });
          if (developmentFilters && !isReset) {
            for (let devFilters of developmentFilters) {
              if (devFilters.id) {
                options = options.map((item) =>
                  item.id === devFilters.id ? { ...item, isactive: true } : item
                );
              }
            }
          }
          setFilterbyOptions(options);
          dispatch({type:"filterbyOptions",value:options})
          setInitialFilterbyOptions(options);
          props.fetchDataFromChild(id, options);
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };

  const handleClosePopup=()=>{
    setHazardInfo(false)
  }

  const resetTrafficAutoUpdate = (path) => {
    if(location.pathname.includes(path)){
       dispatch({type:"isTrafficReset",value:false})
    }
  }

  const loadMapOverlayesLookUp = (type="init") => {
    apiCommonTrigger("get" , Config.API_URL + "/Lookup/advancedmapoverlays")
        .then((response) => {
          resetTrafficAutoUpdate("market-search")
          if (response?.status === 200) {
            if (response.data?.advancedMapOverlays?.length) {
              const index = response.data.advancedMapOverlays.findIndex(ele => ele?.id === ConstantData.advancedMapOverlaysIds.traffic);
              
              if (index !== -1) {
                // response.data.advancedMapOverlays[index].colorCodes?.sort((a, b) => b.id - a.id);
                response.data.advancedMapOverlays[index].descriptions?.sort((a, b) => a.name.localeCompare(b.name));
              }
            }
            try {
                if (type === "update") {
                  response.data.advancedMapOverlays.forEach(item => {
                    const isMatch = item?.id === activeTileSet?.id;
                    item.tileset = Array.isArray(item.tileset)
                      ? item.tileset.map(ele => ({
                          ...ele,
                          isselected: isMatch && ele.tilesetid === activeTileSet.tilesetid
                        }))
                      : null;
                    item.isselected = isMatch;
                  });
                }
          } catch (err) {
            console.error(err);
          }
            setMapOverlaysLookup(response.data?.advancedMapOverlays);
          }
        })
        .catch((error) => handlingCatchError(error));
  };

  useEffect(() => {
    fetchShowbyOptions();
    loadMapOverlayesLookUp(activeTileSet && location.pathname.includes("interactive-map") ? "update" : "init") 
  }, [location]);

  useEffect(()=>{
    setFilterbyOptions(filterOptions)
  },[filterOptions])
  
  useEffect(() => {
    dispatch({ type: "selectedFilters", value: selectedFilters });
    dispatch({ type: "activeCheckList", value: selectedFilters });
    dispatch({ type: "developmentFilters", value: developmentFilters });
  }, [selectedFilters]);

  const handleRadioChange = async (event, fromRadioField) => {
    if (location?.state?.fromPage && fromRadioField)
      location.state.fromPage = "filter";
    setDefaultShowby(event.target.value);
    const selectedRadioId = filterbyOptions
      .filter(
        (item) => item.typeid.toString() === event.target.value.toString()
      )
      .map((item) => item.id);
    setSelectedFilters({ [event.target.value.toString()]: selectedRadioId });
    await props.fetchDataFromChild(event.target.value, filterbyOptions);
  };

  const handleCheckboxChange = (event, id, showByIdValue) => {
    try {
      if (location?.state?.fromPage) location.state.fromPage = "filter";
      const updatedFilterbyOptions = filterbyOptions.map((item) => {
        if (item.id === id) {
          return { ...item, isactive: event.target.checked };
        }
        return item;
      });

      if (showByIdValue == Object.keys(selectedFilters)) {
        dispatch({ type: "activeCheckList", value: selectedFilters });
      }
      setFilterbyOptions(updatedFilterbyOptions);
      dispatch({type:"filterbyOptions",value:updatedFilterbyOptions})
      props.fetchDataFromChild(defaultShowby, updatedFilterbyOptions, showByIdValue == Object.keys(selectedFilters), event.target.checked);

      if (selectedFilters[showByIdValue]) {
        if (event.target.checked) {
          if (!selectedFilters[showByIdValue].includes(id)) {
            const setselectedFilters = selectedFilters;
            setselectedFilters[showByIdValue].push(id);
            setSelectedFilters(setselectedFilters);
          }
        } else {
          const setselectedFilters = selectedFilters;
          const filteredArray = setselectedFilters[showByIdValue].filter(
            (filter) => filter !== id
          );
          setselectedFilters[showByIdValue] = filteredArray;
          setSelectedFilters(setselectedFilters);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  const handleReset = () => {
    if(isDisableCheckBox) return
    dispatch({type:'RESET_APP_STATE'});
    setShowbyOptions(initialShowbyOptions);
    setFilterbyOptions(initialFilterbyOptions);
    dispatch({type:"filterbyOptions",value:initialFilterbyOptions})

    setDefaultShowby(initialDefaultShowby);
    props.fetchDataFromChild(initialDefaultShowby, initialFilterbyOptions);
    fetchShowbyOptions(true);
    loadMapOverlayesLookUp();
    dispatch({ type: 'developmentFilters', value: [] });

    const event = new CustomEvent("myCustomEvent", {
      detail: { bool: true },
    });
    window.dispatchEvent(event);

    resetTrafficAutoUpdate("interactive-map")
    // const filterResetBtn = document.getElementById("map-reset-search-explorer");
    // if (filterResetBtn){
    //   filterResetBtn.dataset.programmatic = "true";
    //   filterResetBtn.click();
    // }
  };

  const keyObject = {
    "5" : "reits" ,
    "4" : "largeops" ,
    "3" : "midops"  ,
    "2" : "smallops"  ,
    "1" : "singleops"  ,
    "7" : "koa"  , 
    "8" : "non-koa" ,
    "9" : "glamping",
    "10" : "non-glamping",
    "11" : "developments",
    "12" : "forsales",
    "13" : "newhousing newhousing-construction",
    "14" : "nationalpark",
    "15" : "statepark",
    "16" : "marine",
    "21" : "rv-boat"
}

const handledevelopmentchange = async (e, id,colorcode) => {
  const updatedOptions = filterbyOptions.map(item => {
    if (item.id === id) {
      const newIsActive = !item.isactive; 
      return { ...item, isactive: newIsActive };
    }
    return item;
  });
  setFilterbyOptions(updatedOptions);
  dispatch({type:"filterbyOptions",value:updatedOptions})
  
  const selectedIds = {
    isBool: false,
    id: id,
    color:colorcode
  };
  let devData = developmentFilters ? [...developmentFilters] : [];
  const isChecked = !filterbyOptions.find(item => item.id === id)?.isactive;
  const existingid = devData.findIndex((item) => item.id === id);
  if (isChecked) {
    devData.push(selectedIds);
  } else{
    devData = developmentFilters.map(item => {
      if (item.id === id) {
        return {
          ...item,
          data: {
            ...devData[existingid].data,
            isdisplay: false,
          },
        };
      }
      return item;
    });
  }
  dispatch({ type: 'developmentFilters', value: devData });
};
const getFilterCheckBoxClassName = (x) => {
  return x?.isactive &&
    x?.name &&
    selectedFilters?.[x?.typeid?.toString()] &&
    selectedFilters?.[x?.typeid?.toString()]?.includes(x?.id)
    ? keyObject?.[x?.id?.toString()] + " count-div"
    : `${x?.id == 13 ? " newhousing-construction count-div" :" count-div"}`;
};
const handleParentChange = (selectedIndex) => {
    const updatedLookUp = mapOverLaysLookUp.map((item, index) => {
    const isSelected = index === selectedIndex;
    const isActive = isSelected ? !item?.isselected : false;
    return {
      ...item,
      isselected: isActive,
      tileset: item.tileset
        ? item.tileset.map((ele, i) => ({
            ...ele,
            isselected:
              isSelected
                ? isActive && i === 0
                : false,
          }))
        : [],
    };
  });
    const isApplyReset = selectedIndex === 0 && activeTileSet.id === ConstantData.advancedMapOverlaysIds.traffic;
    if(!isTrafficReset && isApplyReset){
      dispatch({type:"isTrafficReset",value:true})
    }
    setMapOverlaysLookup(updatedLookUp);
    let selectedData = updatedLookUp[selectedIndex];
    let selectedTileSetDetails = {
      id: selectedData.id,
      colorCodes:selectedData.colorCodes,
      name:selectedData?.name,
      layertype : selectedData.layertype,
      ...selectedData?.tileset[0],
    };
    dispatch({ type: 'activeTileSet' , value : selectedTileSetDetails});
  };

  const handleChildChange = (parentIndex, childIndex) => {
    const updatedLookUp = mapOverLaysLookUp.map((item, index) => {
      const isSelected = index === parentIndex;
      return {
        ...item,
        isselected: isSelected,
        tileset: item.tileset
          ? item.tileset.map((ele, i) => ({
              ...ele,
              isselected: isSelected && i === childIndex ? true : false,
            }))
          : [],
      };
    });
    setMapOverlaysLookup(updatedLookUp);
    let selectedData = updatedLookUp[parentIndex];
    let selectedTileSetDetails = {
      id: selectedData.id,
      colorCodes:selectedData.colorCodes,
       name:selectedData?.name,
      layertype : selectedData.layertype,
      TileFilter:activeTileSet?.id === selectedData?.id ? activeTileSet?.TileFilter : null ,
      ...selectedData?.tileset[childIndex],
    };
    dispatch({ type: 'activeTileSet' , value : selectedTileSetDetails});
  };

  const handleChangeHazard = (item) => {
    dispatch({ type: 'activeTileSet' , value : {...activeTileSet,TileFilter:item.lableid === "-1" ? {"lableid":null,"labletext":null} :item }});
  }

  const handleOpenInfoModal=(item)=>{
    setHazardInfo({show:true,info:item});
  }

  const checkZoomLevel = () =>{
    let zoomLevel = (location.pathname.includes("market-dashboard/interactive-map") ? ConstantData.advancedMapOverlaysIds.trafficZoomLevel : ConstantData.advancedMapOverlaysIds.trafficZoomLevel) ;
    return viewPort.zoom >= zoomLevel ? false :true
  }
  var userDetails = localStorage.getItem('user') !== null ? localStorage.getItem('user') : null;  
  const user = JSON.parse(userDetails || "{}");
  const isFreeUser = (user.usertype || "") === "Free";

    // useEffect(()=>{
    //   if(viewPort.zoom >= ConstantData.advancedMapOverlaysIds.trafficZoomLevel && (!activeTileSet || activeTileSet.id === ConstantData.advancedMapOverlaysIds.none) && !isTrafficReset && (!isFreeUser || (isFreeUser && location.pathname.includes("market-dashboard/interactive-map"))) ){
    //   if(!mapOverLaysLookUp) return;
    //     const updatedLookUp = mapOverLaysLookUp.map((item) => {
    //       const isSelected = item.id === ConstantData.advancedMapOverlaysIds.traffic;
    //       const isActive = isSelected ? true : false;
    //         return {
    //           ...item,
    //           isselected: isActive,
    //           tileset: item.tileset
    //             ? item.tileset.map((ele, i) => ({
    //                 ...ele,
    //                 isselected:
    //                   isSelected
    //                     ? isActive && i === 0
    //                     : false,
    //               }))
    //             : [],
    //         };
    //       });
    //       setMapOverlaysLookup(updatedLookUp);
    //       let trafficedData = updatedLookUp.find((item)=>item.id === ConstantData.advancedMapOverlaysIds.traffic);
    //       let selectedTileSetDetails = {
    //         id: trafficedData.id,
    //         colorCodes:trafficedData.colorCodes,
    //         name:trafficedData?.name,
    //         layertype : trafficedData.layertype,
    //         ...trafficedData?.tileset[0],
    //       };
    //       dispatch({ type: 'activeTileSet' , value : selectedTileSetDetails});
    //   }
    // },[viewPort])

  return (
    <div> 
      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label" className="filter-heading">Show By: <button onClick={handleReset} className="reset-btn" id="reset-btn-filter" disabled={isDisableCheckBox}>Reset</button></FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={defaultShowby || null}
          onChange={(e) => {
            if (!disableShowByFilters) {
              handleRadioChange(e, true);
            }
          }}
          name="showby"
          className="radio-btn"
        >
          {showbyOptions && showbyOptions.length > 0 ? (
            showbyOptions.map((val, index) => (
              <FormControlLabel
                key={index}
                value={val.id}
                control={<Radio disabled={disableShowByFilters} />}
                label={val.name}
              />
            ))
          ) : (
            <Skeleton />
          )}
        </RadioGroup>
      </FormControl>
      <div className="filter-heading mt-2 mb-0">Filter By</div>
      { showbyOptions && showbyOptions.length > 0 ? (
        showbyOptions.map((data, index) => (
          <div key={data?.label + index} className="checkbox_list">
            <FormControl variant="standard">
              {LookupComponent(data.label, data.id === 1)}
              {filterbyOptions &&
                filterbyOptions
                  .filter((y) => y.typeid === data.id)
                  .map((x, idx) => (
                    <FormGroup
                      key={
                        getFilterCheckBoxClassName(x) +
                        idx +
                        data?.label +
                        index
                      }
                      className={getFilterCheckBoxClassName(x)}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={isDisableCheckBox}
                            checked={x.isactive}
                            name={x.id}
                            style={{ color: x.colorcode }}
                            onChange={(e) => {
                              if (!isDisableCheckBox) {
                                handleCheckboxChange(e, x.id, data.id);
                              }
                            }}
                          />
                        }
                        label={x.name}
                        className="submenu_list"
                      />
                      {props.pageType != "intractive" && (
                        <span className="count-ele">{`(${x.profilecount})`}</span>
                      )}
                    </FormGroup>
                  ))}
            </FormControl>
          </div>
        ))
      ) : (
        <Skeleton />
      )}
      <div className="filter-heading mt-2 mb-1">Development and for Sale</div>
      <FormControl variant="standard">
      {
        filterbyOptions && filterbyOptions.filter((x)=>x.typeid === 4).map((x,idx)=>(
          <FormGroup key={idx}   className={ (x.isactive && x.name )  ? keyObject[x.id.toString()] + " count-div" : `${x.id == 13 ? " newhousing-construction count-div" :" count-div"}` }>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={x.isactive}
                            name={x.id}
                            disabled={isDisableCheckBox}
                            style={{ color: x.colorcode }}
                            onChange={(e) => {
                              if (!isDisableCheckBox) {
                                 handledevelopmentchange(e, x.id, x.colorcode);
                              }
                            }}
                            
                          />
                        }
                        label={x.name}
                        className="submenu_list"
                      />
                      {props.pageType != 'intractive' && <span className="count-ele">{`(${x.profilecount})`}</span>  }  
                    </FormGroup>
        ))
      }
      </FormControl>
              <div className="filter-heading mt-2 mb-1" style={{opacity:1}}>Advanced Map Overlays <span>(US Only)</span></div>
              <div className="mapoverlay-values">
              <div   className={(isFreeUser&&!location.pathname.includes("market-dashboard/interactive-map")) ? "free-user-disabled mapoverlay-values" : "mapoverlay-values"}>
               {hazardInfo?.show && hazardInfo?.info && (
<HazardInfoModal show={hazardInfo.show} info={hazardInfo.info} closePopup={handleClosePopup}/>
)}
              {(mapOverLaysLookUp && mapOverLaysLookUp?.length) ? 
              mapOverLaysLookUp?.map((item, index) => {
                return (
                 
                  <div key={index} className="map-overlay-list">
                   
                    <FormGroup row className="count-div" style={{alignItems: 'center'}}>
                    <RadioGroup className="radio-btn overlays-lable-group">
                      <FormControlLabel
                        className={`submenu_mapoverlays ${
                          item.id === ConstantData.advancedMapOverlaysIds.traffic && checkZoomLevel()
                            ? "disable-traffic-layer"
                            : ""
                        }`}
                        control={
                                 <Radio
                                    checked={item.isselected ? true : false}
                                    onChange={() => handleParentChange(index)}
                                   disabled={(item.id === ConstantData.advancedMapOverlaysIds.traffic && checkZoomLevel() ||(isFreeUser&&!location.pathname.includes("market-dashboard/interactive-map")) ) }
                                  />
                        }
                        label={<Typography className="mymarkets-submenu-mapoverlays" style={{opacity: searchPinAppending ? 0.5 : 1}}>{item.name}
                        {item.descriptions && <span className="fonticon-info svg">
                          <FontAwesomeIcon icon={faInfoCircle} onMouseDown={(e)=>e.stopPropagation()} onClick={(e)=>{e.preventDefault(); e.stopPropagation();
                          if(!(item.id === ConstantData.advancedMapOverlaysIds.traffic && checkZoomLevel() ||(isFreeUser&&!location.pathname.includes("market-dashboard/interactive-map")) )){
                           handleOpenInfoModal(item)
                          } }}/>
                        </span>}
                        </Typography>
                      }
                        
                      />
                      
                      </RadioGroup>
                    {item.id === ConstantData.advancedMapOverlaysIds.traffic && checkZoomLevel() ?<p className="info-msg mb-0 ps-1">* Please zoom in to view</p>:""}
                    </FormGroup>

                    {item?.listItems?.length ? (
                      <div
                        style={{ marginLeft: "15px", marginBottom: 0 }}
                        className="hazardForm"
                      >
                        <Select
                          type="select"
                          name={item.name}
                          labelId="fema-dropdown-label"
                          className="mymarkets-submenu-mapoverlays-dropdown"
                          onChange={(event) => {
                              let selectedItem = item.listItems?.find((ele)=>ele?.lableid === event.target.value) 
                              handleChangeHazard(event.target.value === "-1" ? {lableid :"-1" , labletext : ""} :selectedItem, item.name);
                          }}
                          value={activeTileSet?.TileFilter?.lableid || "-1"}
                           disabled={!item.isselected || (isFreeUser&&!location.pathname.includes("market-dashboard/interactive-map"))}                        >
                          <MenuItem value="-1">- Select a hazard -</MenuItem>
                          {item.listItems?.map((item, index) => (
                            <MenuItem value={item.lableid} key={index + 1}>
                              {item.labletext}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    ) : (
                      ""
                    )}
                    {item.tileset?.length > 1 ? (
                      <div
                        style={{
                          marginLeft: "15px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                        className="drop-down_adv-map"
                      >
                        {item.tileset?.map((child, i) => {
                          return (
                            <FormGroup className="submenu_mapoverlays">
                              <RadioGroup className="radio-btn">
                              <FormControlLabel
                                control={
                                  <Radio
                                    checked={child.isselected ? true : false}
                                    onChange={() => handleChildChange(index, i)}
                                    disabled={false|| (isFreeUser&&!location.pathname.includes("market-dashboard/interactive-map"))}
                                    className="filter-by-mapoverlays-radio"
                                  />
                                }
                                label={
                                  <Typography className="mymarkets-submenu-mapoverlays" style={{opacity: searchPinAppending ? 0.5 : 1}}>
                                    {child.labletext}
                                  </Typography>
                                }
                              />
                              </RadioGroup>
                            </FormGroup>
                          );
                        })}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })
              : <Skeleton />}
              </div>
        

  

  </div>

    </div>
   );
 
  

});
